import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import { format } from "date-fns";

import Loading from "../../../common/Loading";

import InformationalTooltip from "../InformationalTooltip";

import COLUMNS from "./columns";

const ProjectSummary = ({ projects, isMobile, loading, dark }) => {
  const handleRowClick = (row) => {
    window.open(`/app/projects/${row.original._id}`, "_blank");
  };

  const props = {
    getTdProps: (state, rowInfo, column) => {
      if (!column.expander) {
        return {
          onClick: () => {
            handleRowClick(rowInfo);
          }
        };
      }
      return {};
    }
  };

  return (
    <div className="content-wrapper project-summary-container">
      <div className="header-section-container">
        <h1>Project Summary</h1>
        <InformationalTooltip
          id="project_summary"
          dark={dark}
          content="All projects with time applied"
        />
      </div>
      {(loading || projects.length === 0) && (
        <div className="loading">
          <Loading css={{ margin: "10px auto 0 auto" }} />
        </div>
      )}

      {!loading && projects.length > 0 && (
        <ReactTable
          {...props}
          className="-highlight"
          columns={COLUMNS}
          data={projects}
          defaultPageSize={10}
          showPageSizeOptions={!isMobile}
          showPagination={projects.length > 10}
          SubComponent={({ original }) => {
            const note = original.notes
              .filter((n) => n.created_by !== "system")
              .reverse()[0];

            return (
              note?.note && (
                <div className="ps-note-wrapper">
                  <div className="ps-note-header">
                    <div>{note.title}</div>
                    <div>
                      <span className="ps-note-user">
                        {note.created_by.split("@")[0]}
                      </span>
                      •
                      <span>
                        {" "}
                        {format(
                          new Date(note.created_on),
                          "MM/dd/yyyy hh:mm a"
                        )}
                      </span>
                    </div>
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: note.note }} />
                </div>
              )
            );
          }}
        />
      )}
    </div>
  );
};

ProjectSummary.propTypes = {
  projects: PropTypes.array,
  isMobile: PropTypes.bool,
  loading: PropTypes.bool,
  dark: PropTypes.bool
};

ProjectSummary.defaultProps = {
  projects: [],
  isMobile: false,
  loading: false,
  dark: false
};

export default ProjectSummary;
